export const darkTheme = {
    "--white": "#111b21",
    "--regular": " SFUIDisplayRegular, sans-serif",
    "--light": " SFUIDisplayLight, sans-serif",
    "--medium": " SFUIDisplayMedium, sans-serif",
    "--bold": " SFUIDisplayBold, sans-serif",
    "--black": " SFUIDisplayBlack, sans-serif",
    "--semibold": " SFUIDisplaySemibold, sans-serif",
    "--thin": " SFUIDisplayThin, sans-serif",
    "--heavy": " SFUIDisplayHeavy, sans-serif",
    "--ultralight": " SFUIDisplayUltralight, sans-serif",
    "--regularNova": " ProximaNova-Regular, sans-serif",
    "--lightNova": " ProximaNova-Light, sans-serif",
    "--SemiboldNova": " ProximaNova-Semibold, sans-serif",
    "--mf-box-layout-bg": "#152434",
    "--parent-top-gap": " 0px",
    "--maxParentheight": " calc(100vh - var(--parent-top-gap))",
    "--mf-theme-color": " #4879f9",
    "--mf-theme-color-bright": " #2698F9",
    "--mf-theme-color-dark": " #2c77d1",
    "--mf-theme-color-rgb": " 72, 121, 249",
    "--mf-heading-bg": " var(--mf-theme-color)",
    "--mf-theme-color-hightlight": " rgba(var(--mf-theme-color-rgb, 0.8))",
    "--mf-list-hover-bg": " rgba(var(--mf-theme-color-rgb), 0.09)",
    "--mf-chat-badge-bg": " rgba(var(--mf-theme-color-rgb), 0.2)",
    "--mf-bgc-recent-chatlist": "#111b21",
    "--mf-primary-dark": " #fff",
    "--mf-secondary-dark": " #fff",
    "--mf-secondary-light": " #fff",
    "--mf-danger-hightlight": " #e24848",
    "--mf-chat-Sub-details": " #73777e",
    "--mf-text-light": " var(--mf-theme-color)",
    "--mf-chat-User-group-name": " var(--mf-theme-color-dark)",
    "--mf-border-common": "#323232",
    "--mf-user-status-sent": " #808080",
    "--mf-user-status-receive": " #ffa500",
    "--mf-chat-bubble-link-color": " var(--mf-theme-color)",
    "--mf-user-status-seen": " rgb(0, 226, 75)",
    "--mf-recentchat-icon": " rgb(118, 118, 118)",
    "--mf-chat-bubble-sender-star-icon": " #fff",
    "--mf-chat-bubble-receiver-star-icon": " #fff",
    "--mf-chat-bubble-receiver-bg": " #3a4358",
    "--mf-chat-bubble-receiver-text": " #000000",
    "--mf-chat-bubble-sender-bg": " var(--mf-theme-color-bright)",
    "--mf-chat-bubble-sender-text": " White",
    "--mf-chat-badge-text": " var(--mf-secondary-light)",
    "--mf-search-input-bg": " #232a2e",
    "--mf-search-input-border":"#31383c",
    "--mf-attachment-bg": " rgba(var(--mf-theme-color-rgb), 0.1)",
    "--mf-attachment-icon-bg": " #0f2a5f",
    "--mf-msgtime": " var(--mf-secondary-light)",
    "--mf-send-message-time": " #949494",
    "--mf-rev-message-time": " #fff",
    "--mf-recent-chat-conversion-bg": "#fff",
    "--mf-chat-conversion-bg": "#111b21",
    "--mf-recentchat-header-bg": "var(--white)",
    "--mf-conversation-header-bg": "var(--white)",
    "--mf-search-input-icon": "#f1f1f1",
    "--mf-search-input-bdr": "#e8e8e8",
    "--mf-message-input-bg": " #111b21",
    "--mf-message-input-border":"#31383c",
    "--mf-clr-typing-area":"#fff",
    "--mf-bgc-recent-chatlist-header":"var(--mf-theme-color)",
    "--mf-menu-name":"#fff",
    "--mf-profile-img-name":"#fff",
    "--mf-bgc-userprofile-header":"#2698f9",
    "--mf-bgc-userprofile-popup":"#232a2e",
    "--mf-profile-popup-text":"#fff",
    "--mf-icons-contactinfo": " #313131",
    "--mf-icons-dropdown-options": " rgba(var(--mf-theme-color-rgb), 0.9)",
    "--mf-icons-recentchat-header": " #f1f1f1",
    "--mf-attachment-dropdown-options": " rgba(var(--mf-theme-color-rgb), 0.9)",
    "--mf-icons-contactinfo-danger": " var(--mf-danger-hightlight)",
    "--mf-profile-view-icon": "  #fff",
    "--mf-chat-input-icons": " #f1f1f1",
    "--mf-profile-popup-edit-icons": "#828282",
    "--mf-option-active": " var(--mf-theme-color)",
    "--mf-option-active-light": " var(--mf-theme-color-rgb, 0.5)",
    "--mf-bg-hover-circle": "var(--mf-list-hover-bg)",
    "--mf-attachment-color-icon": " #fff",
    "--mf-bgc-start-chat-banner-link":"#9dbafc",
    "--mf-contact-info": " #fff",
    "--mf-bgc-newgroup":"#232a2e",
    "--mf-new-group-name":"#f1f1f1",

}

export const MirrorFlyTheme = {
    "--white": "#fff",
    "--regular": " SFUIDisplayRegular, sans-serif",
    "--light": " SFUIDisplayLight, sans-serif",
    "--medium": " SFUIDisplayMedium, sans-serif",
    "--bold": " SFUIDisplayBold, sans-serif",
    "--black": " SFUIDisplayBlack, sans-serif",
    "--semibold": " SFUIDisplaySemibold, sans-serif",
    "--thin": " SFUIDisplayThin, sans-serif",
    "--heavy": " SFUIDisplayHeavy, sans-serif",
    "--ultralight": " SFUIDisplayUltralight, sans-serif",
    "--regularNova": " ProximaNova-Regular, sans-serif",
    "--lightNova": " ProximaNova-Light, sans-serif",
    "--SemiboldNova": " ProximaNova-Semibold, sans-serif",
    "--mf-box-layout-bg": "#D8DBE3",
    "--parent-top-gap": " 0px",
    "--maxParentheight": " calc(100vh - var(--parent-top-gap))",
    "--mf-theme-color": " #4879f9",
    "--mf-theme-color-bright": " #2698F9",
    "--mf-theme-color-dark": " #2c77d1",
    "--mf-theme-color-rgb": " 72, 121, 249",
    "--mf-heading-bg": " var(--mf-theme-color)",
    "--mf-theme-color-hightlight": " rgba(var(--mf-theme-color-rgb, 0.8))",
    "--mf-list-hover-bg": " rgba(var(--mf-theme-color-rgb), 0.09)",
    "--mf-chat-badge-bg": " rgba(var(--mf-theme-color-rgb), 0.2)",
    "--mf-bgc-recent-chatlist": "white",
    "--mf-primary-dark": " #000000",
    "--mf-secondary-dark": " #181818",
    "--mf-secondary-light": " #333333",
    "--mf-danger-hightlight": " #e24848",
    "--mf-chat-Sub-details": " #73777e",
    "--mf-text-light": " var(--mf-theme-color)",
    "--mf-chat-User-group-name": " var(--mf-theme-color-dark)",
    "--mf-border-common": " #efefef",
    "--mf-user-status-sent": " #808080",
    "--mf-user-status-receive": " #ffa500",
    "--mf-chat-bubble-link-color": " var(--mf-theme-color)",
    "--mf-user-status-seen": " rgb(0, 226, 75)",
    "--mf-recentchat-icon": " rgb(118, 118, 118)",
    "--mf-chat-bubble-sender-star-icon": " #fff",
    "--mf-chat-bubble-receiver-star-icon": " #fff",
    "--mf-chat-bubble-receiver-bg": " #fff",
    "--mf-chat-bubble-receiver-text": " #444343",
    "--mf-chat-bubble-sender-bg": " var(--mf-theme-color-bright)",
    "--mf-chat-bubble-sender-text": " White",
    "--mf-chat-badge-text": " var(--mf-secondary-light)",
    "--mf-search-input-bg": " #f1f3f4",
    "--mf-search-input-border":"#e8e8e8",
    "--mf-attachment-bg": " rgba(var(--mf-theme-color-rgb), 0.1)",
    "--mf-attachment-icon-bg": " #0f2a5f",
    "--mf-msgtime": " var(--mf-secondary-light)",
    "--mf-send-message-time": " #949494",
    "--mf-rev-message-time": " #fff",
    "--mf-recent-chat-conversion-bg": "#fff",
    "--mf-chat-conversion-bg": "#fff",
    "--mf-recentchat-header-bg": "#fff",
    "--mf-conversation-header-bg": "#fff",
    "--mf-search-input-icon": "#bac0c2",
    "--mf-search-input-bdr": "#e8e8e8",
    "--mf-message-input-bg": " #fff",
    "--mf-message-input-border":"#e8e8e8",
    "--mf-clr-typing-area":"#363636",
    "--mf-bgc-recent-chatlist-header":"var(--mf-theme-color)",
    "--mf-menu-name":"#fff",
    "--mf-profile-img-name":"#000",
    "--mf-bgc-userprofile-header":"var(--mf-theme-color)",
    "--mf-bgc-userprofile-popup":"#fff",
    "--mf-profile-popup-text":"#fff",
    "--mf-icons-contactinfo": " #313131",
    "--mf-icons-dropdown-options": " rgba(var(--mf-theme-color-rgb), 0.9)",
    "--mf-icons-recentchat-header": " #828282",
    "--mf-attachment-dropdown-options": " rgba(var(--mf-theme-color-rgb), 0.9)",
    "--mf-icons-contactinfo-danger": " var(--mf-danger-hightlight)",
    "--mf-profile-view-icon": "  #fff",
    "--mf-chat-input-icons": " #363636",
    "--mf-profile-popup-edit-icons": "#828282",
    "--mf-option-active": " var(--mf-theme-color)",
    "--mf-option-active-light": " var(--mf-theme-color-rgb, 0.5)",
    "--mf-bg-hover-circle": " #f1f3f4",
    "--mf-attachment-color-icon": " #fff",
    "--mf-bgc-start-chat-banner-link":"#2698f9",
    "--mf-contact-info": " #000",
    "--mf-bgc-newgroup":"#f6f6f6",
    "--mf-new-group-name":"#484848",
};